/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDefinitionDtoValueType } from './CreateDefinitionDtoValueType';
import {
    CreateDefinitionDtoValueTypeFromJSON,
    CreateDefinitionDtoValueTypeFromJSONTyped,
    CreateDefinitionDtoValueTypeToJSON,
} from './CreateDefinitionDtoValueType';
import type { CreateDiscreteNumericListDtoGeometry } from './CreateDiscreteNumericListDtoGeometry';
import {
    CreateDiscreteNumericListDtoGeometryFromJSON,
    CreateDiscreteNumericListDtoGeometryFromJSONTyped,
    CreateDiscreteNumericListDtoGeometryToJSON,
} from './CreateDiscreteNumericListDtoGeometry';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';

/**
 * 
 * @export
 * @interface DiscreteNumericListDto
 */
export interface DiscreteNumericListDto {
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericListDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericListDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericListDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DiscreteNumericListDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscreteNumericListDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscreteNumericListDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericListDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof DiscreteNumericListDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericListDto
     */
    numericId?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericListDto
     */
    unitAbbreviation?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DiscreteNumericListDto
     */
    selectedValues?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DiscreteNumericListDto
     */
    availableValues?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof DiscreteNumericListDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {CreateDefinitionDtoValueType}
     * @memberof DiscreteNumericListDto
     */
    valueType?: CreateDefinitionDtoValueType | null;
    /**
     * 
     * @type {CreateDiscreteNumericListDtoGeometry}
     * @memberof DiscreteNumericListDto
     */
    geometry?: CreateDiscreteNumericListDtoGeometry | null;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericListDto
     */
    $type?: DiscreteNumericListDtoTypeEnum;
}


/**
 * @export
 */
export const DiscreteNumericListDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoDiscreteNumericListDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DiscreteNumericListDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type DiscreteNumericListDtoTypeEnum = typeof DiscreteNumericListDtoTypeEnum[keyof typeof DiscreteNumericListDtoTypeEnum];


/**
 * Check if a given object implements the DiscreteNumericListDto interface.
 */
export function instanceOfDiscreteNumericListDto(value?: unknown): value is DiscreteNumericListDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DiscreteNumericListDtoTypeEnum)[0];
}

export function DiscreteNumericListDtoFromJSON(json: any): DiscreteNumericListDto {
    return DiscreteNumericListDtoFromJSONTyped(json, false);
}

export function DiscreteNumericListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscreteNumericListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': !exists(json, 'dataTypeId') ? undefined : json['dataTypeId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'isRequired': !exists(json, 'isRequired') ? undefined : json['isRequired'],
        'isReadonly': !exists(json, 'isReadonly') ? undefined : json['isReadonly'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'numericId': !exists(json, 'numericId') ? undefined : json['numericId'],
        'unitAbbreviation': !exists(json, 'unitAbbreviation') ? undefined : json['unitAbbreviation'],
        'selectedValues': !exists(json, 'selectedValues') ? undefined : json['selectedValues'],
        'availableValues': !exists(json, 'availableValues') ? undefined : json['availableValues'],
        'decimalPlaces': !exists(json, 'decimalPlaces') ? undefined : json['decimalPlaces'],
        'valueType': !exists(json, 'valueType') ? undefined : CreateDefinitionDtoValueTypeFromJSON(json['valueType']),
        'geometry': !exists(json, 'geometry') ? undefined : CreateDiscreteNumericListDtoGeometryFromJSON(json['geometry']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function DiscreteNumericListDtoToJSON(value?: DiscreteNumericListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'dataTypeId': value.dataTypeId,
        'name': value.name,
        'isRequired': value.isRequired,
        'isReadonly': value.isReadonly,
        'isEnabled': value.isEnabled,
        'iuid': value.iuid,
        'origin': EntityOriginToJSON(value.origin),
        'numericId': value.numericId,
        'unitAbbreviation': value.unitAbbreviation,
        'selectedValues': value.selectedValues,
        'availableValues': value.availableValues,
        'decimalPlaces': value.decimalPlaces,
        'valueType': CreateDefinitionDtoValueTypeToJSON(value.valueType),
        'geometry': CreateDiscreteNumericListDtoGeometryToJSON(value.geometry),
        '$type': value.$type,
    });
}

